@if (alertMessageVisibility) {
  <div [ngClass]="class" class="alert text-center" [class]="'alerte-message-style-' + brand" id="alert-message" role="alert">
    <div>
      <strong [innerHTML]="message"></strong>
    </div>
  </div>
}
